/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
import ManagementList from "./ManagementList";
import History from "./History";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";

const WorkScheduleManagement = (props) => {
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const history = useHistory();
  const [activeTab, setActiveTab] = useState('work-schedule');
  const [detailOpen, setDetailOpen] = useState(false);
  const [formMode, setFormMode] = useState("create");
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'WORK_SCHEDULE_MANAGEMENT')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "WORK_SCHEDULE_MANAGEMENT")
      }
    }
  }, [permissions])

  const _setActiveTab = (value) => {
    history.push(`/workschedule/management?tab=${value}`);
  };

  const tabList = [
    {
      label: "근무일정 관리",
      action: _setActiveTab,
      value: 'work-schedule'
    },
    {
      label: "변경이력",
      action: _setActiveTab,
      value: 'change-history'
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  const headerButtons = [
    {
      label: "근무일정 추가",
      action: () => {
        setDetailOpen(true);
      },
    },
  ];

  return (
    !isEmpty(targetPermission) && (
      <>
        <PageHeader
          title={"근무 일정 관리"}
          activeTab={activeTab}
          tabList={tabList}
          buttons={activeTab === 'work-schedule' && targetPermission.level > 1 ? headerButtons : []}
        />
        <div>
          {activeTab === 'work-schedule' && (
            <ManagementList
              permission={targetPermission}
              detailOpen={detailOpen}
              setDetailOpen={setDetailOpen}
              mode={formMode}
              setMode={setFormMode}
            />
          )}
          {activeTab === 'change-history' && <History />}
        </div>
      </>
    ));
};

export default WorkScheduleManagement;
